import { render, staticRenderFns } from "./EditPaymentMethod.vue?vue&type=template&id=59b18b7e&"
import script from "./EditPaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./EditPaymentMethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports